/**
 * Model Quality dashboard availability.
 *
 * The backend endpoint is open to any authenticated org (no server-side
 * gate), so the client-side flag is always true. Previously this was
 * gated to a single hardcoded org UUID for gradual rollout validation;
 * that phase is complete.
 */
export const isModelQualityEnabled = (
  _orgUuid: string | undefined | null
): boolean => true;
